module.exports = __webpack_public_path__ + "img/img5.28dbcf41.png";